'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSize = require('../../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _sizes = require('../../../constants/sizes');

var _layout = require('../layout');

var _layout2 = _interopRequireDefault(_layout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChatIcon = function (_React$Component) {
	_inherits(ChatIcon, _React$Component);

	function ChatIcon() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, ChatIcon);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChatIcon.__proto__ || Object.getPrototypeOf(ChatIcon)).call.apply(_ref, [this].concat(args))), _this), _this.getIcon = function (width, height, primary, secondary) {
			return _react2.default.createElement(
				'svg',
				{ id: 'Chat_v2', 'data-name': 'Chat v2', xmlns: 'http://www.w3.org/2000/svg', width: '24', height: '24', viewBox: '0 0 24 24' },
				_react2.default.createElement('rect', { id: 'Bounding_box', 'data-name': 'Bounding box', width: '24', height: '24', fill: 'transparent' }),
				_react2.default.createElement(
					'g',
					{ id: 'chat', transform: 'translate(1 1.5)' },
					_react2.default.createElement('path', { id: 'atom_icon_chat_default', 'data-name': 'atom/icon/chat/default', fill: primary, d: 'M1.91,22a1,1,0,0,1-.982-1.19l.779-4.034A10.968,10.968,0,0,1,0,10.875C0,5.082,5.291,0,11.323,0A10.789,10.789,0,0,1,22,10.875,10.79,10.79,0,0,1,11.323,21.75a13.7,13.7,0,0,1-5.258-1.07L2.224,21.95A.991.991,0,0,1,1.91,22Zm4.234-3.4a1.008,1.008,0,0,1,.477.121,11.21,11.21,0,0,0,4.7,1.028A8.788,8.788,0,0,0,20,10.875,8.788,8.788,0,0,0,11.323,2C6.356,2,2,6.147,2,10.875A8.959,8.959,0,0,0,3.589,16a.993.993,0,0,1,.16.759l-.535,2.761,2.615-.865A1.043,1.043,0,0,1,6.143,18.6Z', transform: 'translate(0 0)' }),
					_react2.default.createElement('path', { id: 'Union_16', 'data-name': 'Union 16', fill: secondary, d: 'M-1738-1273.5a1,1,0,0,1,1-1,1,1,0,0,1,1,1,1,1,0,0,1-1,1A1,1,0,0,1-1738-1273.5Zm-4,0a1,1,0,0,1,1-1,1,1,0,0,1,1,1,1,1,0,0,1-1,1A1,1,0,0,1-1742-1273.5Zm-4,0a1,1,0,0,1,1-1,1,1,0,0,1,1,1,1,1,0,0,1-1,1A1,1,0,0,1-1746-1273.5Z', transform: 'translate(1752 1284.5)' })
				)
			);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	_createClass(ChatIcon, [{
		key: 'render',
		value: function render() {
			var size = this.props.size || _sizes.Sizes.md;
			size = (0, _getSize2.default)(size);
			return _react2.default.createElement(
				_layout2.default,
				this.props,
				this.getIcon(size, size, this.props.primary, this.props.secondary)
			);
		}
	}]);

	return ChatIcon;
}(_react2.default.Component);

exports.default = ChatIcon;